import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import React, { useContext, useEffect, useMemo } from 'react';
import { createGlobalStyle, css, StyleSheetManager } from 'styled-components';
import { emptyObj, emptyCSSTemplateFunc } from './constants';
import { ThemeContext } from './ThemeContext';
import { getStyleSheetTarget } from './utils'; // import { Heart } from './Heart';

import { setLoadEffectCssComponent, useLoadStyles } from './dynamicLoad';

/**
 * 获取 css 模板 array
 * @param props 部分 CommonGlobalStyleProps
 * @returns
 */
var getGlobalCssArray = function getGlobalCssArray(props) {
  var onlyTemplate = props.onlyTemplate,
    extraTemplate = props.extraTemplate,
    pro = props.pro,
    uiType = props.uiType;
  var templateArr = []; // choerodon-ui 和 hzero-ui两个特殊  判断可以优化一下

  if (uiType === 'choerodon-ui') {
    var item = pro ? 'pro' : 'base';
    templateArr.push(onlyTemplate ? onlyTemplate[item] : props.css);
    templateArr.push(extraTemplate && extraTemplate[item]);
  } else if (uiType === 'hzero-ui') {
    templateArr.push(onlyTemplate ? onlyTemplate['hzero'] : props.css);
    templateArr.push(extraTemplate && extraTemplate['hzero']);
  } else {
    templateArr.push(onlyTemplate || props.css);
    templateArr.push(extraTemplate);
  }
  templateArr = templateArr.filter(function (t) {
    return t;
  });
  return templateArr;
};
var getGlobalCss = function getGlobalCss(props) {
  var _props$scope = props.scope,
    scope = _props$scope === void 0 ? [] : _props$scope,
    global = props.global,
    partialSelector = props.partialSelector;
  var template = getGlobalCssArray(props);
  if (partialSelector) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", " {\n        ", "\n      }\n    "])), partialSelector, template);
  }
  return scope && !global && scope.length > 0 ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", " {\n          ", "\n        }\n      "])), scope.join(','), template) : template;
};
export var CommonGlobalStyle = createGlobalStyle(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n", "\n"])), getGlobalCss);
export var StyleComponent = function StyleComponent(props) {
  var name = props.name,
    uiType = props.uiType,
    global = props.global,
    data = props.data,
    schema = props.schema,
    scopeList = props.scopeList,
    _props$cssTemplate = props.cssTemplate,
    cssTemplate = _props$cssTemplate === void 0 ? '' : _props$cssTemplate,
    targetIdPrefix = props.targetIdPrefix,
    partialSelector = props.partialSelector;
  var fieldSplits = name.split('/');
  var fieldName = fieldSplits[fieldSplits.length - 1];
  var _ref = data[fieldName] || emptyObj,
    onlyTemplate = _ref.onlyTemplate,
    extraTemplate = _ref.extraTemplate,
    __global = _ref.__global;
  var target = useMemo(function () {
    return getStyleSheetTarget("".concat(targetIdPrefix || '').concat(uiType, "-").concat(name), uiType);
  }, [name, targetIdPrefix, uiType]);
  useEffect(function () {
    return function () {
      return target.childNodes.forEach(function (i) {
        return i.remove();
      });
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyleSheetManager, {
    target: target
  }, /*#__PURE__*/React.createElement(CommonGlobalStyle, {
    schema: schema,
    name: fieldName,
    uiType: uiType,
    pro: !name.startsWith('comp'),
    css: cssTemplate,
    scope: scopeList,
    extraTemplate: extraTemplate,
    onlyTemplate: onlyTemplate,
    global: global || __global,
    data: data,
    partialSelector: partialSelector
  }));
};
/**
 * 创建一个样式组件
 * @param name // fieldName取值问题，可以是{name}，也可以是xxxxx/{name}
 * @param cssTemplate
 */

export function createStyleComponent(name, cssTemplate, global) {
  var id = "".concat(Math.random().toString().slice(2, 10)).concat(Date.now());
  var fieldSplits = name.split('/');
  var fieldName = fieldSplits[fieldSplits.length - 1];
  return {
    name: name,
    fieldName: fieldName,
    id: "".concat(fieldName, "-").concat(id),
    global: global,
    cssTemplate: cssTemplate
  };
}
function isLoadStyleComponentCreator(params) {
  return params.listenCompKey !== undefined && params.loadCssData !== undefined;
}
/**
 * 创建入口样式组件，用于汇总所有样式组件
 * @param styles
 */

export function createMainStyleComponent(opts) {
  var name = opts.name,
    _styles = opts.styles;
  var uidKey = "".concat(Math.random().toString().slice(2, 10)).concat(Date.now());
  var hasLoadItem = false;
  var styles = _styles.filter(function (item, index) {
    if (isLoadStyleComponentCreator(item)) {
      setLoadEffectCssComponent("".concat(name, "::").concat(item.listenCompKey), item.loadCssData, uidKey, index);
      hasLoadItem = true;
      return false;
    }
    return true;
  });
  var _useLoadStyles = hasLoadItem ? function () {
    return useLoadStyles(name, uidKey);
  } : function () {
    return null;
  };
  var MainStyleComponent = function MainStyleComponent(_ref2) {
    var partialSelector = _ref2.partialSelector,
      targetPrefix = _ref2.targetPrefix;
    var contextValue = useContext(ThemeContext);
    var _contextValue$resolve = contextValue.resolvedTheme,
      resolvedTheme = _contextValue$resolve === void 0 ? emptyObj : _contextValue$resolve,
      scopeList = contextValue.scopeList,
      schema = contextValue.schema;
    var loadStyles = _useLoadStyles();
    var stylesConfig = useMemo(function () {
      return [].concat(_toConsumableArray(styles), _toConsumableArray(loadStyles || []));
    }, [loadStyles]);
    var elements = useMemo(function () {
      // const refCount: any = {};
      var eles = stylesConfig.map(function (_ref3) {
        var id = _ref3.id,
          global = _ref3.global,
          fieldName = _ref3.fieldName,
          compName = _ref3.name,
          cssTemplate = _ref3.cssTemplate;
        if (!id) {
          return false;
        } // let shouldRender = true;
        // const hasOnly = (resolvedTheme || emptyObj)[fieldName]?.onlyTemplate;
        // if (!refCount[compName] && hasOnly) {
        //   refCount[compName] = true;
        // } else if (refCount[compName] && hasOnly) {
        //   shouldRender = false;
        // }

        var _ref4 = resolvedTheme[fieldName] || emptyObj,
          onlyTemplate = _ref4.onlyTemplate,
          extraTemplate = _ref4.extraTemplate;
        var isPro = !compName.startsWith('comp');
        var templateArr = getGlobalCssArray({
          css: cssTemplate,
          extraTemplate: extraTemplate,
          onlyTemplate: onlyTemplate,
          pro: isPro,
          uiType: name
        });
        if (!(templateArr && templateArr.length > 0 && templateArr.some(function (t) {
          return t && t !== emptyCSSTemplateFunc;
        }))) {
          return false;
        }
        return /*#__PURE__*/(
          // shouldRender && (
          React.createElement(StyleComponent, {
            global: global,
            name: compName,
            uiType: name,
            cssTemplate: cssTemplate,
            partialSelector: partialSelector,
            schema: schema,
            scopeList: scopeList,
            data: resolvedTheme,
            key: "".concat(name, "-").concat(id),
            targetIdPrefix: targetPrefix
          }) // )
        );
      }).filter(Boolean);
      return eles;
    }, [schema, resolvedTheme, scopeList, partialSelector, targetPrefix, stylesConfig]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, elements);
  };
  MainStyleComponent.uiName = name;
  return MainStyleComponent;
}